import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class PochtaTariffRatePartDto
*  
*/
export class PochtaTariffRatePartDto extends ActiveModel {

  /**
  * rate
  *   */
  @ActiveField()
  rate?: null | number


  /**
  * vat
  *   */
  @ActiveField()
  vat?: null | number
}
